const contentful = require("contentful");

const client = contentful.createClient({
    space: process.env.VUE_APP_CMS_SPACE,
    accessToken: process.env.VUE_APP_CMS_TOKEN,
  });

export default client;